import { GetAssetFolderURLBase } from "@vived/vivedlearning_host";
import assetSystemPlugin from "../../Data/assetSystemPlugin.json";

export class GetAssetFolderURL extends GetAssetFolderURLBase {
  action = (callback) => {
    callback(`https://apps-bucket-${assetSystemPlugin.stage}-6655.s3.us-east-1.amazonaws.com/assets/${assetSystemPlugin.id}/${assetSystemPlugin.version}`);
  };
}
